import essApi from "../axios/essApi";

class ProjectService {

    async getProjects() {
        return Promise.resolve(essApi.get(`user-project`));
    }

    async getProjectsById(reqBody) {
      return Promise.resolve(essApi.get(`/user-project-by-user-id/${reqBody}`));
  }

    async addProjects(reqBody) {
        return Promise.resolve(essApi.post(`user-project`, reqBody));
    }
    async updateProjects(reqBody) {
        return Promise.resolve(essApi.put(`user-project/${reqBody.id}`, reqBody));
    }
    async deleteProjects(id) {
        return Promise.resolve(essApi.delete(`user-project/${id}`));
    }
}

export default ProjectService;
